import { options } from "pages/NurseOut/ExamHistory/config";
import { useState } from "react";
import { FIELD_TYPE, FORMAT_TIME } from "types/enums";
import { DataFormField } from "types/models/input-field-type";
const { INPUT, SELECT,TEXT_AREA, DATE, COLOR, COMBO_BOX, TIME,NUMBER,DATE_DISABLE_NO_DAY } = FIELD_TYPE;
const css = { xs: 24, sm: 24, md: 24, lg: 8, xl: 8 };
  const dataFieldss: DataFormField[] = [
    {
      type: DATE,
      label: "Ngày tháng năm",
      name: "ngayThangNam",
      disable: false,
      expand: false,
     // rules: [{ required: true, message: "Chưa nhập loại công việc" }],
      css: css,
      wrapperCol: { xs: 24, sm: 14, md: 16, lg: 14, xl: 14 },
      labelCol: { xs: 24, sm: 10, md: 8, lg: 10, xl: 10 },
      optionsTime: { showTime: true, format: FORMAT_TIME.dateTime_4 },
    },
    {
      type: INPUT,
      label: "Số đến",
      name: "soDen",
      disable: false,
      expand: false,
     // rules: [{ required: true, message: "Chưa nhập loại công việc" }],
      css: css,
      wrapperCol: { xs: 24, sm: 14, md: 16, lg: 14, xl: 14 },
      labelCol: { xs: 24, sm: 10, md: 8, lg: 10, xl: 10 },
    },
    {
      type: INPUT,
      label: "Nơi gửi",
      name: "noiGui",
      disable: false,
      expand: false,
     // rules: [{ required: true, message: "Chưa nhập loại công việc" }],
      css: css,
      wrapperCol: { xs: 24, sm: 14, md: 16, lg: 14, xl: 14 },
      labelCol: { xs: 24, sm: 10, md: 8, lg: 10, xl: 10 },
    },
    {
      type: INPUT,
      label: "Số ký hiệu",
      name: "soKyHieu",
      disable: false,
      expand: false,
     // rules: [{ required: true, message: "Chưa nhập loại công việc" }],
      css: css,
      wrapperCol: { xs: 24, sm: 14, md: 16, lg: 14, xl: 14 },
      labelCol: { xs: 24, sm: 10, md: 8, lg: 10, xl: 10 },
    },
    {
      type: DATE,
      label: "Ngày tháng văn bản",
      name: "ngayThangNamVanBan",
      disable: false,
      expand: false,
     // rules: [{ required: true, message: "Chưa nhập loại công việc" }],
      css: css,
      wrapperCol: { xs: 24, sm: 14, md: 16, lg: 14, xl: 14 },
      labelCol: { xs: 24, sm: 10, md: 8, lg: 10, xl: 10 },
      optionsTime: { showTime: true, format: FORMAT_TIME.dateTime_4 },
    },
    {
      type: TEXT_AREA,
      label: "Tên loại và trích yếu nội dung",
      name: "tenLoaiVaTrichYeu",
      disable: false,
      expand: false,
     // rules: [{ required: true, message: "Chưa nhập loại công việc" }],
      css: css,
      wrapperCol: { xs: 24, sm: 14, md: 16, lg: 14, xl: 14 },
      labelCol: { xs: 24, sm: 10, md: 8, lg: 10, xl: 10 },
    },
    {
      type: INPUT,
      label: "Đơn vị hoặc người nhận",
      name: "noiNhan",
      disable: false,
      expand: false,
     // rules: [{ required: true, message: "Chưa nhập loại công việc" }],
      css: css,
      wrapperCol: { xs: 24, sm: 14, md: 16, lg: 14, xl: 14 },
      labelCol: { xs: 24, sm: 10, md: 8, lg: 10, xl: 10 },
    },
    {
      type: INPUT,
      label: "Ký nhận",
      name: "kiNhan",
      disable: false,
      expand: false,
     // rules: [{ required: true, message: "Chưa nhập loại công việc" }],
      css: css,
      wrapperCol: { xs: 24, sm: 14, md: 16, lg: 14, xl: 14 },
      labelCol: { xs: 24, sm: 10, md: 8, lg: 10, xl: 10 },
    },
    {
      type: TEXT_AREA,
      label: "Ghi chú",
      name: "ghiChu",
      disable: false,
      expand: false,
     // rules: [{ required: true, message: "Chưa nhập loại công việc" }],
      css: css,
      wrapperCol: { xs: 24, sm: 14, md: 16, lg: 14, xl: 14 },
      labelCol: { xs: 24, sm: 10, md: 8, lg: 10, xl: 10 },
    },
  ];
export { dataFieldss };
